// userEvents.js
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';  // Make sure the path is correct for your project structure

export const USER_EVENT_TYPES = {
  POINTS_EARNED: 'points_earned',
  RANK_UP: 'rank_up',
  ACHIEVEMENT_UNLOCKED: 'achievement_unlocked',
  STREAK_MILESTONE: 'streak_milestone'
};

export const recordUserEvent = async (userId, eventType, eventData) => {
  const userEventsRef = collection(db, "users", userId, "events");
  
  try {
    await addDoc(userEventsRef, {
      type: eventType,
      data: eventData,
      timestamp: serverTimestamp()
    });
    
    // This could be expanded to send push notifications, emails, etc.
    // For now, it just records the event in Firestore
    
    return true;
  } catch (error) {
    console.error("Error recording user event:", error);
    return false;
  }
};